export const pqContentData = [
    {
        "id":"demographicId01",
        "category":"demographic",
        "backgroundImageURL":"https://d3lcz8vpax4lo2.cloudfront.net/client_images/insticator/michael-henry-396981-unsplash_yjlsnn+-min.jpg",
        "type":"demographic",
        "title":"Demographic Questionnaire",
        "description":"Answer questions about your demographic profile",
        "questions":[
            {
                "id":"questionId01",
                "type":"profile",
                "answersType":"input",
                "background":"https://d3lcz8vpax4lo2.cloudfront.net/client_images/insticator/michael-henry-396981-unsplash_yjlsnn+-min.jpg",
                "backgroundColor":null,
                "text":"What is your date of birth?",
                "queuePosition":0,
                "answers":[

                ],
                "questionSignature":"questionSignature",
                "placeholder":"YYYY-MM-DD",
                "validation":"(19|20)\\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])"
            },
            {
                "id":"questionId03",
                "type":"profile",
                "answersType":"select",
                "background":"https://d3lcz8vpax4lo2.cloudfront.net/client_images/insticator/michael-henry-396981-unsplash_yjlsnn+-min.jpg",
                "backgroundColor":null,
                "text":"What is your race?",
                "queuePosition":2,
                "answers":[
                    {
                        "id":"questionId03-answerId01",
                        "text":"White"
                    },
                    {
                        "id":"questionId03-answerId02",
                        "text":"Black, or African American"
                    },
                    {
                        "id":"questionId03-answerId03",
                        "text":"Native American or Alaska Native"
                    },
                    {
                        "id":"questionId03-answerId04",
                        "text":"Asian - Asian Indian"
                    },
                    {
                        "id":"questionId03-answerId05",
                        "text":"Asian - Chinese"
                    },
                    {
                        "id":"questionId03-answerId06",
                        "text":"Asian - Filipino"
                    },
                    {
                        "id":"questionId03-answerId07",
                        "text":"Asian - Japanese"
                    },
                    {
                        "id":"questionId03-answerId08",
                        "text":"Asian - Korean"
                    },
                    {
                        "id":"questionId03-answerId09",
                        "text":"Asian - Vietnamese"
                    },
                    {
                        "id":"questionId03-answerId10",
                        "text":"Asian - Other"
                    },
                    {
                        "id":"questionId03-answerId11",
                        "text":"Pacific Islander/Native Hawaiian"
                    },
                    {
                        "id":"questionId03-answerId12",
                        "text":"Pacific Islander - Guamanian"
                    },
                    {
                        "id":"questionId03-answerId13",
                        "text":"Pacific Islander - Samoan"
                    },
                    {
                        "id":"questionId03-answerId14",
                        "text":"Other Pacific Islander"
                    },
                    {
                        "id":"questionId03-answerId15",
                        "text":"Some other race"
                    },
                    {
                        "id":"questionId03-answerId16",
                        "text":"Prefer not to answer"
                    }
                ],
                "questionSignature":"questionSignature1"
            },
            {
                "id":"questionId04",
                "type":"profile",
                "answersType":"select",
                "background":"https://d3lcz8vpax4lo2.cloudfront.net/client_images/insticator/michael-henry-396981-unsplash_yjlsnn+-min.jpg",
                "backgroundColor":null,
                "text":"Are you of Hispanic, Latino, or Spanish origin?",
                "queuePosition":3,
                "answers":[
                    {
                        "id":"questionId04-answerId01",
                        "text":"Not Hispanic/Latino/Spanish origin"
                    },
                    {
                        "id":"questionId04-answerId02",
                        "text":"Yes Mexican/Mexican-American"
                    },
                    {
                        "id":"questionId04-answerId03",
                        "text":"Yes, Cuban"
                    },
                    {
                        "id":"questionId04-answerId04",
                        "text":"Yes, Argentina"
                    },
                    {
                        "id":"questionId04-answerId05",
                        "text":"Yes, Colombia"
                    },
                    {
                        "id":"questionId04-answerId06",
                        "text":"Yes, Ecuador"
                    },
                    {
                        "id":"questionId04-answerId07",
                        "text":"Yes, El Salvador"
                    },
                    {
                        "id":"questionId04-answerId08",
                        "text":"Yes, Guatemala"
                    },
                    {
                        "id":"questionId04-answerId09",
                        "text":"Yes, Nicaragua"
                    },
                    {
                        "id":"questionId04-answerId10",
                        "text":"Yes, Panama"
                    },
                    {
                        "id":"questionId04-answerId11",
                        "text":"Yes, Peru"
                    },
                    {
                        "id":"questionId04-answerId12",
                        "text":"Yes, Spain"
                    },
                    {
                        "id":"questionId04-answerId13",
                        "text":"Yes, Venezuela"
                    },
                    {
                        "id":"questionId04-answerId014",
                        "text":"Yes, another country"
                    },
                    {
                        "id":"questionId04-answerId15",
                        "text":"Prefer not to answer"
                    }
                ],
                "questionSignature":"questionSignature2"
            },
            {
                "id":"questionId05",
                "type":"profile",
                "answersType":"select",
                "background":"https://d3lcz8vpax4lo2.cloudfront.net/client_images/insticator/michael-henry-396981-unsplash_yjlsnn+-min.jpg",
                "backgroundColor":null,
                "text":"What is your current annual household income before taxes?",
                "queuePosition":5,
                "answers":[
                    {
                        "id":"questionId05-answerId1",
                        "text":"Less than $14,999"
                    },
                    {
                        "id":"questionId05-answerId2",
                        "text":"$15,000 to $19,999"
                    },
                    {
                        "id":"questionId05-answerId3",
                        "text":"$20,000 to $24,999"
                    },
                    {
                        "id":"questionId05-answerId4",
                        "text":"$25,000 to $29,999"
                    },
                    {
                        "id":"questionId05-answerId5",
                        "text":"$30,000 to $34,999"
                    },
                    {
                        "id":"questionId05-answerId6",
                        "text":"$35,000 to $39,999"
                    },
                    {
                        "id":"questionId05-answerId7",
                        "text":"$40,000 to $44,999"
                    },
                    {
                        "id":"questionId05-answerId8",
                        "text":"$45,000 to $49,999"
                    },
                    {
                        "id":"questionId05-answerId9",
                        "text":"$50,000 to $54,999"
                    },
                    {
                        "id":"questionId05-answerId10",
                        "text":"$55,000 to $59,999"
                    },
                    {
                        "id":"questionId05-answerId12",
                        "text":"$60,000 to $64,999"
                    },
                    {
                        "id":"questionId05-answerId13",
                        "text":"$65,000 to $69,999"
                    },
                    {
                        "id":"questionId05-answerId14",
                        "text":"$70,000 to $74,999"
                    },
                    {
                        "id":"questionId05-answerId15",
                        "text":"$75,000 to $79,999"
                    },
                    {
                        "id":"questionId05-answerId16",
                        "text":"$80,000 to $84,999"
                    },
                    {
                        "id":"questionId05-answerId17",
                        "text":"$85,000 to $89,999"
                    },
                    {
                        "id":"questionId05-answerId18",
                        "text":"$90,000 to $94,999"
                    },
                    {
                        "id":"questionId05-answerId19",
                        "text":"$95,000 to $99,999"
                    },
                    {
                        "id":"questionId05-answerId20",
                        "text":"$100,000 to $124,999"
                    },
                    {
                        "id":"questionId05-answerId21",
                        "text":"$125,000 to $149,999"
                    },
                    {
                        "id":"questionId05-answerId22",
                        "text":"$150,000 to $174,999"
                    },
                    {
                        "id":"questionId05-answerId23",
                        "text":"$175,000 to $199,999"
                    },
                    {
                        "id":"questionId05-answerId24",
                        "text":"$200,000 to $249,999"
                    },
                    {
                        "id":"questionId05-answerId25",
                        "text":"$250,000 and above"
                    },
                    {
                        "id":"questionId05-answerId26",
                        "text":"Prefer not to answer"
                    }
                ],
                "questionSignature":"questionSignature4"
            }
        ]
    },

    {
        "id":"lifestyleId01",
        "category":"events and attractions",
        "backgroundImageURL":null,
        "type":"lifestyle",
        "title":null,
        "description":null,
        "questions":[
            {
                "id":"lifestyleQuestion01",
                "type":"profile",
                "answersType":"select",
                "background":null,
                "backgroundColor":null,
                "text":"How often do you visit state or national parks?",
                "queuePosition":null,
                "answers":[
                    {
                        "id":"lifestyleQuestion01-answerId01",
                        "text":"A few times a month"
                    },
                    {
                        "id":"lifestyleQuestion01-answerId02",
                        "text":"A few times a week"
                    },
                    {
                        "id":"lifestyleQuestion01-answerId03",
                        "text":"A few times a year"
                    },
                    {
                        "id":"lifestyleQuestion01-answerId04",
                        "text":"Almost never"
                    }
                ],
                "questionSignature":"questionSignature4"
            },
            {
                "id":"lifestyleQuestion02",
                "type":"profile",
                "answersType":"select",
                "background":null,
                "backgroundColor":null,
                "text":"Do you like or loathe malls during the holidays?",
                "queuePosition":null,
                "answers":[
                    {
                        "id":"lifestyleQuestion02-answerId01",
                        "text":"Like! all of it. it's fun."
                    },
                    {
                        "id":"lifestyleQuestion02-answerId02",
                        "text":"Loathe! too many things."
                    },
                    {
                        "id":"lifestyleQuestion02-answerId3",
                        "text":"Other / no opinion"
                    }
                ],
                "questionSignature":"questionSignature5"
            },
            {
                "id":"lifestyleQuestion03",
                "type":"profile",
                "answersType":"select",
                "background":null,
                "backgroundColor":null,
                "text":"How often do you attend a sporting event?",
                "queuePosition":null,
                "answers":[
                    {
                        "id":"lifestyleQuestion03-answerId01",
                        "text":"2-3 times per month"
                    },
                    {
                        "id":"lifestyleQuestion03-answerId02",
                        "text":"4 or more times per month"
                    },
                    {
                        "id":"lifestyleQuestion03-answerId03",
                        "text":"A few times a year"
                    },
                    {
                        "id":"lifestyleQuestion03-answerId04",
                        "text":"About once a month"
                    },
                    {
                        "id":"lifestyleQuestion03-answerId05",
                        "text":"Never"
                    }
                ],
                "questionSignature":"questionSignature6"
            }
        ]
    }
];
